<template>
  <div class="location-detail">
    <wrld-container
      :breadcrumbs="this.breadcrumbs"
      :pageIsLoading="pageIsLoading"
    >
      <!-- <div v-if="this.locations.error !== null"> -->
        <!-- TODO: add to i18n -->
        <!-- <h2>Location with ID {{route.params.locationID}} does not exist.</h2>
      </div> -->
      <div>
        <wrld-out-of-box :title="$tc('locations.location', 1) + ' - ' + (location.name ? location.name : 'Unnamed')">
          <template v-slot:headerBtns>
            <div v-if="isManageable">
              <v-btn outlined @click="gotoEdit()">
                <v-icon>edit</v-icon>{{$t('buttons.edit')}}
              </v-btn>
              <wrld-confirm-btn v-model="delete_modal_opened" @confirm="callDeleteLocation()">
                <v-btn outlined color="accent" @click="delete_modal_opened=true">
                  <v-icon>delete</v-icon>{{$t('buttons.delete')}}
                </v-btn>
              </wrld-confirm-btn>
            </div>
          </template>
        </wrld-out-of-box>

        <!-- Overview -->
        <wrld-box :headerTitle="$t('overview')">
          <template v-slot:boxContent>
            <v-container
              class="pa-4"
            >
              <v-row>
                <v-col sm="5" class="right-border">
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.reference')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.ref}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.name')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.name}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.company')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.company.name}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.type')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.type}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col sm="7">
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.equipment')}}</span>
                        </v-col>
                        <v-col>
                          <v-chip
                            label
                            small
                            color="kazan"
                            text-color="white"
                            v-for="(equipment, i) in location.equipment"
                            :key="i"
                          >
                            <v-icon left>label</v-icon>
                            {{equipment}} <!-- TODO: Add to i18n for every equipment -->
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">Accessibility</span> <!-- TODO: add to i18n -->
                        </v-col>
                        <v-col>
                          <v-chip
                            label
                            small
                            color="red"
                            text-color="white"
                            v-for="(accessibility, i) in location.accessibility"
                            :key="i"
                          >
                            <v-icon left>label</v-icon>
                            {{accessibility}} <!-- TODO: Add to i18n for every equipment -->
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </wrld-box>

        <!-- Adress and map -->
        <wrld-box :headerTitle="$t('locations.address')">
          <template v-slot:boxContent>
            <v-container
              class="pa-4"
            >
              <v-row>
                <v-col cols="12" sm="10" md="8" lg="4">
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.street')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.address.street}}, {{location.address.streetNo}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.city')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.address.city}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.postal_code')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.address.postalCode}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.country')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.address.country}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col
                          cols="4"
                          class="text-left"
                        >
                          <span class="subheading">{{$t('locations.coordinates')}}</span>
                        </v-col>
                        <v-col offset-sm="1" class="text-left">
                          <span>{{location.coordinates.lat}}, {{location.coordinates.lng}}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="8">
                  <GmapMap
                    :center="{lat:location.coordinates.lat, lng:location.coordinates.lng}"
                    :zoom="15"
                    style="width: 100%; height: 100%; min-height: 450px"
                  >
                    <GmapMarker
                      :position="{lat:location.coordinates.lat, lng:location.coordinates.lng}"
                      @mouseover="infoWindowOpened = true"
                      @mouseout="infoWindowOpened = false"
                    >
                      <GmapInfoWindow
                        :opened="infoWindowOpened"
                        @closeclick="infoWindowOpened = false"
                      >
                        <div>
                          {{location.company}} <br>
                          {{location.address.street}} {{location.address.street_number}}, {{location.address.city}}
                        </div>
                      </GmapInfoWindow>
                    </GmapMarker>
                  </GmapMap>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </wrld-box>

        <!-- Opening hours -->
        <wrld-box :headerTitle="$t('locations.opening_hours')">
          <template v-slot:boxContent>
            <v-container
              :class="['px-4', 'pb-4', isManageable?'pt-1':'pt-4']"
            >
              <!-- TODO: Add special opening hours select (for groups/companies/...) to work (now is only mocked)-->
              <!-- <v-select
                class="opening-hours-select"
                :items="['Default', 'Group A', 'Group B', 'Company Abc', 'Company xyz']"
                flat
                hide-details
                v-model="hoursFor"
                v-if="isManageable"
              ></v-select> -->
              <h3 v-if="Object.keys(openingsHours).length === 0">{{$t('locations.no_openings_in_location')}}</h3>
              <v-row
                
                
                v-for="(hours, index) in openingsHours"
                :key="index"
              >
                <v-col
                  sm="3"
                  class="text-left"
                >
                  <span class="subheading">
                    <strong>{{index}}</strong>
                  </span>
                </v-col>
                <v-col sm="9">
                  <span
                    class="subheading pr-4"
                    v-for="(range, index) in hours"
                    :key="index"
                  >
                    {{range}}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </template>
        </wrld-box>
      </div>
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import { companyService, locationService } from '@/_services'

export default {

  name: 'LocationDetail2',
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' }
      ],
      location: {},
      infoWindowOpened: false,
      hoursFor: 'Default',
      isManageable: true,
      pageIsLoading: false,
      delete_modal_opened: false
    }
  },
  computed: {
    ...mapState(['route', 'locations', 'companies']),
    openingsHours () {
      let dateMap = {
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        0: 'Sunday'
      }
      let openingHours = {}
      this.location.openingHours.forEach(oh => {
        let localDayName = this.$i18n.t('days.' + dateMap[oh.day])
        if (openingHours[localDayName] == null) {
          openingHours[localDayName] = []
        }
        openingHours[localDayName].push(`${oh.from.hours}:${oh.from.minutes + (oh.from.minutes < 10 ? '0' : '')} - ${oh.to.hours}:${oh.to.minutes}`)
      })
      return openingHours
    }
  },
  methods: {
    ...mapActions({
      deleteLocation: 'deleteLocation',
      showSnackbar: 'showSnackbar'
    }),
    callDeleteLocation () {
      this.deleteLocation(this.route.params.locationID)
      let snackMsg = ''
      let snackColor = ''
      if (this.locations.error) {
        snackMsg = this.$i18n.t('snacbars.error')
        snackColor = 'errorr'
      } else {
        snackMsg = this.$i18n.t('snackbars.location_deleted')
        snackColor = 'success'
      }
      this.showSnackbar({ message: snackMsg, color: snackColor })
      router.push({ name: 'Locations' })
    },
    gotoEdit () {
      let locationID = this.route.params.locationID
      router.push({ name: 'LocationEdit2', params: { companyID: this.route.params.companyID, locationID: locationID } })
    },
    async fetchData () {
      this.pageIsLoading = true

      this.location = await locationService.getLocation(this.route.params.companyID, this.route.params.locationID)
      let company = await companyService.getCompany(this.route.params.companyID)
      this.$set(this.location, 'company', company)

      this.breadcrumbs.push({ text: this.location.company.name, disabled: false, href: '#/companies/' + this.route.params.companyID + '?tab=locations' })
      this.breadcrumbs.push({ text: this.$i18n.tc('locations.location', 1) + ' ' + this.$i18n.t('detail'), disabled: true })

      this.pageIsLoading = false
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
  .subheading {
    font-weight: 600;
  }
  .opening-hours-select {
    max-width: 180px;
    padding-bottom: 15px;
  }
  .contact-mail {
    text-decoration: none;
    padding-left: 5px;

    &:hover {
      color: #006c70;
    }
  }
  .right-border {
    border-right: 1px lightgray solid;
  }
</style>
